import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  image: string;
  userName: string;
}

const initialState: UserState = {
  image: "",
  userName: "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<{ image: string; userName: string }>) {
      state.image = action.payload.image;
      state.userName = action.payload.userName;
    },
    resetUser(state) {
      state.image = initialState.image;
      state.userName = initialState.userName;
    },
  },
});

export const { setUser, resetUser } = userSlice.actions;

export default userSlice.reducer;
